import { CommonModule } from '@angular/common';
import { Component, input, OnInit } from '@angular/core';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SidebarService } from './sidebar.service';

export interface MenuItem {
  label: string;
  icon?: string;
  route?: string;
  hasAccess?: boolean;
  children?: MenuItem[];
}

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterModule],
  providers: [SidebarService],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {

  collapsed = input<boolean>(false);

  constructor(
    private sidebarService: SidebarService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.loadMenu();
    this.autoExpandMenu();
  }

  menuItems: MenuItem[] = [];

  expandedSubmenus: Set<string> = new Set();

  toggleSubmenu(label: string) {
    if (this.expandedSubmenus.has(label)) {
      this.expandedSubmenus.delete(label);
    } else {
      this.expandedSubmenus.add(label);
    }
  }

  isSubmenuExpanded(label: string): boolean {
    return this.expandedSubmenus.has(label);
  }

  loadMenu() {
    this.menuItems = this.sidebarService.getMenuItens();
  }

  autoExpandMenu() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        if (event.url && event.url.startsWith('/process')) {
          this.expandedSubmenus.add('Process');
        }
        if (
          event.url &&
          (event.url.includes('/imports/checkin') ||
            event.url.includes('checkin-tools') ||
            event.url.includes('checkin-import-transport') ||
            event.url.includes('checkin-resumo'))
        ) {
          this.expandedSubmenus.add('Importação');
          this.expandedSubmenus.add('4.2 - Checkin');
        }
        if (
          event.url &&
          (event.url.includes('pesquisar-remessas') ||
            event.url.includes('busca-remessa'))
        ) {
          this.expandedSubmenus.add('Importação');
          this.expandedSubmenus.add('4.2 - Checkin');
          this.expandedSubmenus.add('Process');
        }
      });

    if (this.router.url && this.router.url.startsWith('/process')) {
      this.expandedSubmenus.add('Process');
    }
    if (
      this.router.url &&
      (this.router.url.includes('/imports/checkin') ||
        this.router.url.includes('checkin-tools') ||
        this.router.url.includes('checkin-import-transport') ||
        this.router.url.includes('checkin-resumo'))
    ) {
      this.expandedSubmenus.add('Importação');
      this.expandedSubmenus.add('4.2 - Checkin');
    }
    if (
      this.router.url &&
      (this.router.url.includes('pesquisar-remessas') ||
        this.router.url.includes('busca-remessa'))
    ) {
      this.expandedSubmenus.add('Importação');
      this.expandedSubmenus.add('4.2 - Checkin');
      this.expandedSubmenus.add('Process');
    }
  }

}
